export default __webpack_public_path__ + "static/media/gamepad_black.63920968.svg";